export default __webpack_public_path__ + "static/media/join-pool.8aa765c3.svg";